import { createStandardAction } from 'typesafe-actions'

export const SET_FILE = 'SET_FILE'

export const setFile = createStandardAction(SET_FILE)<File>()